import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicPagesComponent } from './public-pages.component';
import { CommonsModule } from '../../commons/commons.module';
import { PagesComponentsModule } from '../components/pages-components.module';

@NgModule({
  declarations: [PublicPagesComponent],
  imports: [CommonModule, CommonsModule, PagesComponentsModule],
})
export class PublicPagesModule {}
